import React from 'react'

import ReactCountryFlag from "react-country-flag"

const Location = ({ store }) => {
    return (
        <>
            { store?.country && (
                <ReactCountryFlag countryCode={store.country?.alpha2Code} svg />
            )}

            <small className="align-self-center mx-2">
                { store?.city || store?.country?.name }
            </small>
        </>
    )
}

export default Location
